// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ixkz","col":"styles_col__UXIXh","actions":"styles_actions__2vJJQ","conflict":"styles_conflict__U4qry"};